// import React, { useState, useEffect, useRef } from "react";
// import { Button, Table, Modal, Form, Pagination } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";
// import callingleads from "../../assets/images/Lead Formate.csv";
// import { useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";
// import { BsThreeDots } from "react-icons/bs";
// import { MdSecurityUpdateGood } from "react-icons/md";
// import { SiConvertio } from "react-icons/si";
// import { MdOutlineHistoryToggleOff } from "react-icons/md";
// import { FaFileCsv } from "react-icons/fa6";
// import { BsFiletypeXlsx } from "react-icons/bs";
// import { useLocation } from "react-router-dom";
// import {Link} from 'react-router-dom'
// import axios from "axios";
// import { FaPlus } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// function UploadPropertyLeadCSV() {
//   const location = useLocation();
//   const [status, setStatus] = useState("");
//   const navigate = useNavigate();
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [leads, setLeads] = useState([]);
//   const [listLoading, setListLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);

//   const [filters, setFilters] = useState({
//     name: "",
//     mobile: "",
//     requirement: "",
//     status: "",
//     from_date: "",
//     to_date: "",
//   });

  
//   const isNewStatusPage = () => {
//     const params = new URLSearchParams(location.search);
//     return params.get("status") === "New";
//   };

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const statusParam = params.get("status");
//     if (statusParam) {

//       console.warn("statusParam", statusParam);
//       setIsFilterActive(true);

//       setFilters((prev) => ({
//         ...prev,
//         status: statusParam,
//       }));
//       fetchLeads(
//         { ...filters, status: statusParam },
//         page
//       );
//     } else {
//       console.warn("wanning data", filters);
//       fetchLeads(filters, page);
//     }

//   }, [location.search]);

//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const inputRef = useRef(null);

//   const token = localStorage.getItem("token");
//   const userType = localStorage.getItem("userType");
//   const [editData, setEditData] = useState({
//     id: "",
//     status: "",
//     remark: "",
//     next_follow_up_date: "",
//     followup_time: "",
//   });


//   const handleFetch = () => {
//     fetchLeads(filters, 1);
//   };

//   const toSentenceCase = (str) => {
//     if (!str) return "";
//     return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
//   };
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

 
//   const handleCheckboxChange = (leadId) => {
//     setSelectedLeads(prev =>
//       prev.includes(leadId)
//         ? prev.filter(id => id !== leadId)
//         : [...prev, leadId]
//     );
//   };

  
//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedLeads([]);
//     } else {
//       const allLeadIds = leads.map(lead => lead.id);
//       setSelectedLeads(allLeadIds);
//     }
//     setSelectAll(!selectAll);
//   };

  
//   const handleDeleteSelected = async () => {
//     if (selectedLeads.length === 0) {
//       Swal.fire("Warning", "Please select at least one lead to delete", "warning");
//       return;
//     }

//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: `If you delete this lead, you can not revert it back , please verify and then delete ${selectedLeads.length} lead(s)`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Delete",
//     });

//     if (result.isConfirmed) {
//       try {
//         const res = await fetch(`${API_URL}/lead-delete-list-only-new`, {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ ids: selectedLeads }),
//         });

//         const data = await res.json();

//         if (res.ok && data?.status == "1") {
//           Swal.fire("Success", data?.message || "Leads deleted successfully!", "success");
//           setSelectedLeads([]);
//           setSelectAll(false);
//           navigate("/calling-lead-report");
//           fetchLeads(filters, page);
//         } else {
//           Swal.fire("Error", data?.message || "Failed to delete leads", "error");
//         }
//       } catch (err) {
//         console.error(err);
//         Swal.fire("Error", "Network error while deleting leads", "error");
//       }
//     }
//   };

//   const fetchLeads = async (searchParams = {}, currentPage = 1) => {
//     setListLoading(true);
//     try {
//       const params = new URLSearchParams({
//         ...searchParams,
//         page: currentPage,
//       }).toString();

//       const res = await fetch(`${API_URL}/lead-csv-list?${params}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data = await res.json();

//       if (res.ok && data?.status === "1") {
//         setLeads(data.data || []);
//         setPage(currentPage);
//         setTotalPages(data.totalPages || 1);
//         // Reset selection when leads change
//         setSelectedLeads([]);
//         setSelectAll(false);
//       } else {
//         Swal.fire("Error", data?.message || "Failed to fetch leads", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", "Network error while fetching leads", "error");
//     } finally {
//       setListLoading(false);
//     }
//   };

//   useEffect(() => {
//   }, []);

//   const handleSearch = () => {
//     fetchLeads(filters, 1);
//     const payload = {
//       from_date: filters.from_date ? new Date(filters.from_date).toISOString() : null,
//       to_date: filters.to_date ? new Date(filters.to_date).toISOString() : null,
//     };
//   };

//   const handlePageChange = (newPage) => {
//     fetchLeads(filters, newPage);
//   };

//   const handleUploadSubmit = async () => {
//     if (!file) {
//       Swal.fire("Warning", "Please select a CSV file!", "warning");
//       return;
//     }

//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("leadCsv", file);

//       const res = await fetch(`${API_URL}/lead-create-csv`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       const data = await res.json();

//       if (res.ok && data?.success === "1") {
//         Swal.fire("Success", data?.message || "CSV uploaded successfully!", "success");
//         setShowModal(false);
//         setFile(null);
//         fetchLeads(filters, page);
//       } else {
//         Swal.fire("Error", data?.message || "Failed to upload CSV", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", err.message || "Network error while uploading CSV", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditLead = async (leadId) => {
//     try {
//       const res = await fetch(`${API_URL}/lead-csv-edit`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ id: leadId })
//       });

//       const data = await res.json();

//       if (res.ok && data?.status === "1" && data?.data?.length > 0) {
//         const lead = data.data[0];

//         setEditData({
//           id: lead.id,
//           name: lead.name || "",
//           mobile: lead.mobile || "",
//           alt_mobile: lead.alt_mobile || "",
//           city: lead.city || "",
//           job_title: lead.job_title || "",
//           budget: lead.budget || "",
//           requirement: lead.requirement || "",
//           status: lead.status || "",
//           remark: lead.remark || "",
//           followup_time: lead.followup_time || "",
//           next_follow_up_date: lead.next_follow_up_date || "",
//           assign_by_subadmin: lead.assign_by_subadmin || "",
//           assign_by_subadmin_email: lead.assign_by_subadmin_email || ""
//         });

//         setShowEditModal(true);
//       } else {
//         Swal.fire("Error", data?.message || "Failed to fetch lead details", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", "Network error while fetching lead details", "error");
//     }
//   };

//   const handleUpdateLead = async () => {
//     try {
//       const res = await fetch(`${API_URL}/lead-csv-update`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(editData),
//       });

//       const data = await res.json();

//       if (res.ok && data?.success === "1") {
//         Swal.fire("Success", data?.message || "Lead updated successfully!", "success");
//         setShowEditModal(false);
//         fetchLeads(filters, page);
//       } else {
//         Swal.fire("Error", data?.message || "Failed to update lead", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", "Network error while updating lead", "error");
//     }
//   };

//   const handleDownloadExcel = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await fetch(`${process.env.REACT_APP_API_URL}/lead-csv-list-export`, {
//         method: "GET",
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!res.ok) throw new Error("Failed to fetch data");
//       const json = await res.json(); // JSON data
//       const ws = XLSX.utils.json_to_sheet(json.data);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Leads");
//       XLSX.writeFile(wb, "leads.xlsx");
//     } catch (err) {
//       console.error(err);
//       alert("Excel download failed");
//     }
//   };

//   // return (
//   //   <div className="card mt-2">
//   //     <div className="card-header flex-wrap-mobile d-flex justify-content-between align-items-md-center gap-2">
//   //       <div className="titlepage ">
//   //         <h3 className="m-0">Social Media Leads </h3>
//   //       </div>
//   //       <div className="d-flex gap-2 flex-wrap">
//   //         <Link to="/calling-create-lead" className="btn btn-success d-flex align-items-center"
//   //         >
//   //           <FaPlus className="me-1"/>
//   //           Add Calling Lead</Link>
//   //         <Button onClick={() => setShowModal(true)}>   <FaFileCsv className="fs-5" /> Upload CSV</Button>
//   //         <Button variant="primary" className="d-flex gap-2 align-items-center fw-bold" onClick={handleDownloadExcel}>
//   //           <BsFiletypeXlsx className="fs-5 " />
//   //           Download Excel
//   //         </Button>

//   //         {/* Delete Selected Button - Only show when status=New and leads are selected */}
//   //         {isNewStatusPage() && selectedLeads.length > 0 && (
//   //           <Button variant="danger" onClick={handleDeleteSelected}>
//   //             Delete Selected ({selectedLeads.length})
//   //           </Button>
//   //         )}

//   //         <button
//   //           className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//   //           onClick={handleToggle}
//   //         >
//   //           {isFilterActive ? (
//   //             <>
//   //               <MdFilterAltOff />
//   //             </>
//   //           ) : (
//   //             <>
//   //               <MdFilterAlt />
//   //             </>
//   //           )}
//   //         </button>
//   //       </div>
//   //     </div>
//   //     {/* Search Filters */}
//   //     <div className="card-body">
//   //       {isFilterActive && (
//   //         <div className="d-flex gap-2 mb-3 flex-wrap-mobile">
//   //           <input
//   //             type="text"
//   //             placeholder="Name"
//   //             value={filters.name}
//   //             onChange={(e) =>
//   //               setFilters({ ...filters, name: e.target.value })
//   //             }
//   //           />
//   //           <input
//   //             type="date"
//   //             value={filters.from_date}
//   //             onChange={(e) => setFilters({ ...filters, from_date: e.target.value })}
//   //           />
//   //           <input
//   //             type="date"
//   //             value={filters.to_date}
//   //             onChange={(e) => setFilters({ ...filters, to_date: e.target.value })}
//   //           />
//   //           <input
//   //             type="text"
//   //             placeholder="Mobile"
//   //             value={filters.mobile}
//   //             onChange={(e) =>
//   //               setFilters({ ...filters, mobile: e.target.value })
//   //             }
//   //           />
//   //           <input
//   //             type="text"
//   //             placeholder="Requirement"
//   //             value={filters.requirement}
//   //             onChange={(e) =>
//   //               setFilters({ ...filters, requirement: e.target.value })
//   //             }
//   //           />
//   //           <select
//   //             value={filters.status}
//   //             onChange={(e) => setFilters({ ...filters, status: e.target.value })}
//   //           >
//   //             <option value="">All Status</option>
//   //             <option value="Already Purchased">Already Purchased</option>
//   //             <option value="Call not Pickup">Call not Pickup</option>
//   //             <option value="Customer Self Call Back When He Will Come">Customer Self Call Back When He Will Come</option>
//   //             <option value="In Follow Up">In Follow Up</option>
//   //             <option value="Details sent visit not done">Details sent visit not done</option>
//   //             <option value="In Follow Up Booking Done">In Follow Up Booking Done</option>
//   //             <option value="In Follow Up Booking Done Payment Pending">In Follow Up Booking Done Payment Pending</option>
//   //             <option value="In Follow Up Hot">In Follow Up Hot</option>
//   //             <option value="In Follow Up Site Visit Done Booking Pending">In Follow Up Site Visit Done Booking Pending</option>
//   //             <option value="Invalid Mobile Number">Invalid Mobile Number</option>
//   //             <option value="Looking in Commercial Use">Looking in Commercial Use</option>
//   //             <option value="Looking in Different Location">Looking in Different Location</option>
//   //             <option value="Looking in Low Budget">Looking in Low Budget</option>
//   //             <option value="M Profile">M Profile</option>
//   //             <option value="Not Interested">Not Interested</option>
//   //             <option value="Not Responding">Not Responding</option>
//   //             <option value="New">New</option>
//   //           </select>
//   //           <Button onClick={handleSearch}>Search</Button>
//   //         </div>
//   //       )}
//   //       {listLoading ? (
//   //         <p>Loading leads...</p>
//   //       ) : leads.length === 0 ? (
//   //         <p>No leads found.</p>
//   //       ) : (
//   //         <>
//   //           <Table striped bordered hover responsive>
//   //             <thead>
//   //               <tr>
//   //                 {/* Checkbox column - Only show when status=New */}
//   //                 {isNewStatusPage() && (
//   //                   <th>
//   //                     Check All
//   //                     <Form.Check
//   //                       type="checkbox"
//   //                       checked={selectAll}
//   //                       onChange={handleSelectAll}
//   //                     />
//   //                   </th>
//   //                 )}
//   //                 <th>#</th>
//   //                 <th>Name</th>
//   //                 <th>Mobile</th>
//   //                 <th>Alt Mobile</th>
//   //                 <th>City</th>
//   //                 <th>Lead Date</th>
//   //                 <th>Budget</th>
//   //                 <th>Assign By</th>
//   //                 <th>Assign To</th>
//   //                 <th>Job Title</th>
//   //                 <th>PlatForm</th>
//   //                 <th>Requirement</th>
//   //                 <th>Remark</th>
//   //                 <th>Status</th>
//   //                 <th>Next Follow Up Date</th>
//   //                 <th>Next Follow Up Timing</th>
//   //                 <th>Action</th>

//   //               </tr>
//   //             </thead>
//   //             <tbody>
//   //               {leads.map((lead, idx) => (
//   //                 <tr key={lead.id || idx}>
//   //                   {/* Checkbox cell - Only show when status=New */}
//   //                   {isNewStatusPage() && (
//   //                     <td>
//   //                       <Form.Check
//   //                         type="checkbox"
//   //                         checked={selectedLeads.includes(lead.id)}
//   //                         onChange={() => handleCheckboxChange(lead.id)}
//   //                       />
//   //                     </td>
//   //                   )}
//   //                   <td>{((page - 1) * 100) + idx + 1}</td>
//   //                   <td>{toSentenceCase(lead.name)}</td>
//   //                   <td>{lead.mobile}</td>
//   //                   <td>{lead.alt_mobile || "-"}</td>
//   //                   <td>{toSentenceCase(lead.city)}</td>
//   //                   <td>
//   //                     {(() => {
//   //                       if (!lead.lead_date) return "—"; // or "No date"
//   //                       const date = new Date(lead.lead_date);
//   //                       if (isNaN(date)) return "Invalid Date";

//   //                       const day = String(date.getDate()).padStart(2, "0");
//   //                       const month = String(date.getMonth() + 1).padStart(2, "0");
//   //                       const year = date.getFullYear();
//   //                       return `${day}-${month}-${year}`;
//   //                     })()}
//   //                   </td>

//   //                   <td>{toSentenceCase(lead.budget) || "-"}</td>
//   //                   <td>
//   //                     <div className="table-cell-remark">
//   //                       {lead.assign_by_subadmin_email ? lead.assign_by_subadmin_email : "-"}
//   //                     </div>
//   //                   </td>

//   //                   <td>
//   //                     <div className="table-cell-remark">
//   //                       {lead.assign_to_subadmin_email ? lead.assign_to_subadmin_email : "-"}
//   //                     </div>
//   //                   </td>
//   //                   <td>
//   //                     <div className="table-cell-remark">
//   //                       {toSentenceCase(lead.job_title)}
//   //                     </div>
//   //                   </td>
//   //                   <td>
//   //                     <div className="table-cell-remark">
//   //                       {toSentenceCase(lead.plat_form)}
//   //                     </div>
//   //                   </td>
//   //                   <td>
//   //                     <div className="table-cell-remark">
//   //                       {toSentenceCase(lead.requirement)}
//   //                     </div>
//   //                   </td>
//   //                   <td>
//   //                     <div className="table-cell-remark">
//   //                       {toSentenceCase(lead.remark) || "-"}
//   //                     </div>
//   //                   </td>
//   //                   <td>
//   //                     <strong
//   //                       style={{
//   //                         color: lead.status === "New" ? "green" : "red",
//   //                         fontWeight: "bold"
//   //                       }}
//   //                     >
//   //                       {toSentenceCase(lead.status)}
//   //                     </strong>
//   //                   </td>

//   //                   <td>
//   //                     {(() => {
//   //                       if (!lead.next_follow_up_date) return "—"; // no date provided

//   //                       let dateString = lead.next_follow_up_date;

//   //                       // 🔄 If date is in DD-MM-YYYY format, convert it to YYYY-MM-DD
//   //                       if (dateString.includes("-")) {
//   //                         const parts = dateString.split("-");
//   //                         if (parts[0].length === 2) {
//   //                           // Looks like DD-MM-YYYY
//   //                           dateString = `${parts[2]}-${parts[1]}-${parts[0]}`;
//   //                         }
//   //                       }

//   //                       const date = new Date(dateString);
//   //                       if (isNaN(date)) return "Invalid Date";

//   //                       const day = String(date.getDate()).padStart(2, "0");
//   //                       const month = String(date.getMonth() + 1).padStart(2, "0");
//   //                       const year = date.getFullYear();
//   //                       const formattedDate = `${day}-${month}-${year}`;

//   //                       const today = new Date();
//   //                       const todayDay = today.getDate();
//   //                       const todayMonth = today.getMonth();
//   //                       const todayYear = today.getFullYear();

//   //                       let color = "black";
//   //                       if (
//   //                         date.getFullYear() === todayYear &&
//   //                         date.getMonth() === todayMonth &&
//   //                         date.getDate() === todayDay
//   //                       ) {
//   //                         color = "green";
//   //                       } else if (date < today) {
//   //                         color = "red";
//   //                       }

//   //                       return <span style={{ color }}>{formattedDate}</span>;
//   //                     })()}
//   //                   </td>

//   //                   <td>
//   //                     {lead.followup_time
//   //                       ? (() => {
//   //                         const followUpDate = new Date(lead.next_follow_up_date);
//   //                         const today = new Date();
//   //                         today.setHours(0, 0, 0, 0);
//   //                         followUpDate.setHours(0, 0, 0, 0);

//   //                         let color = "black";
//   //                         if (followUpDate.getTime() === today.getTime()) {
//   //                           color = "green";
//   //                         } else if (followUpDate < today) {
//   //                           color = "red";
//   //                         }

//   //                         const [hourStr, min] = lead.followup_time.split(":");
//   //                         let hour = parseInt(hourStr);
//   //                         const ampm = hour >= 12 ? "PM" : "AM";
//   //                         hour = hour % 12;
//   //                         if (hour === 0) hour = 12;
//   //                         const time12 = `${String(hour).padStart(2, "0")}:${min} ${ampm}`;

//   //                         return <span style={{ color }}>{time12}</span>;
//   //                       })()
//   //                       : "-"}
//   //                   </td>
//   //                   <td className="d-flex gap-2">
//   //                     <div className="dropdown">
//   //                       <button
//   //                         className="btn light btn-action dropdown-toggle"
//   //                         type="button"
//   //                         id={`dropdownMenuButton-${lead.id}`}
//   //                         data-bs-toggle="dropdown"
//   //                         aria-expanded="false"
//   //                       >
//   //                         <BsThreeDots size={20} />
//   //                       </button>
//   //                       <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${lead.id}`}>
//   //                         <li className="dropdown-item">
//   //                           <button
//   //                             className="btn view_btn btn-sm me-1"
//   //                             onClick={() => handleEditLead(lead.id)}
//   //                             title="Update"
//   //                           >
//   //                             <MdSecurityUpdateGood className="me-2" /> Update
//   //                           </button>
//   //                         </li>
//   //                         <li className="dropdown-item">
//   //                           <button
//   //                             className="btn edit_btn btn-sm me-1"
//   //                             onClick={() => navigate(`/convert-calling-lead/${lead.id}`)}
//   //                             title="Convert"
//   //                           >
//   //                             <SiConvertio className="me-2" /> Convert
//   //                           </button>
//   //                         </li>
//   //                         <li className="dropdown-item">
//   //                           <button
//   //                             className="btn btn-danger btn-sm"
//   //                             title="Calling Remark History"
//   //                             onClick={() => navigate(`/calling-remark-history/${lead.id}`)}
//   //                           >
//   //                             <MdOutlineHistoryToggleOff className="me-2" /> Calling Remark History
//   //                           </button>
//   //                         </li>
//   //                       </ul>
//   //                     </div>
//   //                   </td>
//   //                 </tr>
//   //               ))}
//   //             </tbody>

//   //           </Table>

//   //           {/* Your Custom Pagination */}
//   //           <div className="d-flex justify-content-end">
//   //             <Pagination>
//   //               <Pagination.Prev
//   //                 onClick={() => handlePageChange(page - 1)}
//   //                 disabled={page === 1}
//   //               />

//   //               <Pagination.Item
//   //                 active={1 === page}
//   //                 onClick={() => handlePageChange(1)}
//   //               >
//   //                 1
//   //               </Pagination.Item>

//   //               {page > 3 && <Pagination.Ellipsis />}

//   //               {page > 2 && (
//   //                 <Pagination.Item
//   //                   onClick={() => handlePageChange(page - 1)}
//   //                 >
//   //                   {page - 1}
//   //                 </Pagination.Item>
//   //               )}

//   //               {page !== 1 && page !== totalPages && (
//   //                 <Pagination.Item active>{page}</Pagination.Item>
//   //               )}

//   //               {page < totalPages - 1 && (
//   //                 <Pagination.Item
//   //                   onClick={() => handlePageChange(page + 1)}
//   //                 >
//   //                   {page + 1}
//   //                 </Pagination.Item>
//   //               )}

//   //               {page < totalPages - 2 && <Pagination.Ellipsis />}

//   //               {totalPages > 1 && (
//   //                 <Pagination.Item
//   //                   active={totalPages === page}
//   //                   onClick={() => handlePageChange(totalPages)}
//   //                 >
//   //                   {totalPages}
//   //                 </Pagination.Item>
//   //               )}

//   //               <Pagination.Next
//   //                 onClick={() => handlePageChange(page + 1)}
//   //                 disabled={page === totalPages}
//   //               />
//   //             </Pagination>
//   //           </div>
//   //         </>
//   //       )}
//   //     </div>
//   //     {/* CSV Upload Modal */}
//   //     <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Upload Property Social Media Leads CSV</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body className="text-center">
//   //         <input
//   //           type="file"
//   //           accept=".csv"
//   //           ref={inputRef}
//   //           onChange={(e) => setFile(e.target.files[0])}
//   //           style={{ display: "none" }}
//   //         />
//   //         <Button onClick={() => inputRef.current && inputRef.current.click()}>
//   //           {file ? "Change CSV" : "Select CSV"}
//   //         </Button>
//   //         <p className="mt-2">{file ? file.name : "No file selected"}</p>
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <div className="d-flex justify-content-between w-100">
//   //           <div className="downloadtemplate">
//   //             <a href={callingleads} download="Lead Formate.csv">
//   //               <Button variant="success">
//   //                 Download Excel Template
//   //               </Button>
//   //             </a>
//   //           </div>

//   //           <div className="d-flex gap-2">
//   //             <Button
//   //               variant="success"
//   //               disabled={loading}
//   //               onClick={handleUploadSubmit}
//   //             >
//   //               {loading ? "Uploading..." : "Upload"}
//   //             </Button>
//   //             <Button variant="danger" onClick={() => setShowModal(false)}>
//   //               Close
//   //             </Button>
//   //           </div>
//   //         </div>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     {/* ✅ Edit Lead Modal */}
//   //     <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Update Calling Leads</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         <Form>
//   //           <Form.Group className="mb-2">
//   //             <Form.Label>Status</Form.Label>
//   //             <Form.Select
//   //               value={editData.status || ""}
//   //               onChange={(e) => setEditData({ ...editData, status: e.target.value })}
//   //               className="text-dark"
//   //             >
//   //               <option value="">All Status</option>
//   //               <option value="Already Purchased">Already Purchased</option>
//   //               <option value="Call not Pickup">Call not Pickup</option>
//   //               <option value="Customer Self Call Back When He Will Come">Customer Self Call Back When He Will Come</option>
//   //               <option value="In Follow Up">In Follow Up</option>
//   //               <option value="Details sent visit not done">Details sent visit not done</option>
//   //               <option value="In Follow Up Booking Done">In Follow Up Booking Done</option>
//   //               <option value="In Follow Up Booking Done Payment Pending">In Follow Up Booking Done Payment Pending</option>
//   //               <option value="In Follow Up Hot">In Follow Up Hot</option>
//   //               <option value="In Follow Up Site Visit Done Booking Pending">In Follow Up Site Visit Done Booking Pending</option>
//   //               <option value="Invalid Mobile Number">Invalid Mobile Number</option>
//   //               <option value="Looking in Commercial Use">Looking in Commercial Use</option>
//   //               <option value="Looking in Different Location">Looking in Different Location</option>
//   //               <option value="Looking in Low Budget">Looking in Low Budget</option>
//   //               <option value="M Profile">M Profile</option>
//   //               <option value="Not Interested">Not Interested</option>
//   //               <option value="Not Responding">Not Responding</option>
//   //               <option value="New">New</option>

//   //             </Form.Select>
//   //           </Form.Group>

//   //           <Form.Group className="mb-2">
//   //             <Form.Label>Remark</Form.Label>
//   //             <Form.Control
//   //               as="textarea"
//   //               rows={3}
//   //               value={editData.remark}
//   //               onChange={(e) => setEditData({ ...editData, remark: e.target.value })}
//   //             />
//   //           </Form.Group>

//   //           <Form.Group className="mb-2">
//   //             <Form.Label>Next Follow Up Date</Form.Label>
//   //             <Form.Control
//   //               type="date"
//   //               value={editData.next_follow_up_date}
//   //               onChange={(e) =>
//   //                 setEditData({ ...editData, next_follow_up_date: e.target.value })
//   //               }
//   //             />
//   //           </Form.Group>
//   //         </Form>

//   //         <Form.Group className="mb-2">
//   //           <Form.Label>Next Follow Up Time</Form.Label>
//   //           <div className="d-flex">
//   //             <Form.Control
//   //               type="time"
//   //               value={editData.followup_time || ""}
//   //               onChange={(e) =>
//   //                 setEditData({ ...editData, followup_time: e.target.value || null })
//   //               }
//   //               placeholder="NA"
//   //             />
//   //             <button
//   //               type="button"
//   //               className="btn btn-outline-secondary ms-2"
//   //               onClick={() =>
//   //                 setEditData({ ...editData, followup_time: null })
//   //               }
//   //             >
//   //               NA
//   //             </button>
//   //           </div>
//   //         </Form.Group>
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="primary" onClick={handleUpdateLead}>
//   //           Update
//   //         </Button>
//   //         <Button variant="danger" onClick={() => setShowEditModal(false)}>
//   //           Cancel
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //   </div>
//   // );

//     return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               📞
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Social Media Leads
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage, upload and convert your social media leads
//               </p>
//             </div>

//             {/* Action Buttons */}
//             <div className="d-flex gap-2 flex-wrap">
//               <Link
//                 to="/calling-create-lead"
//                 className="btn btn-success d-flex align-items-center"
//               >
//                 <FaPlus className="me-1" /> Add Calling Lead
//               </Link>
//               <Button
//                 onClick={() => setShowModal(true)}
//                 className="d-flex align-items-center gap-2"
//               >
//                 <FaFileCsv className="fs-5" /> Upload CSV
//               </Button>
//               <Button
//                 variant="primary"
//                 className="d-flex gap-2 align-items-center fw-bold"
//                 onClick={handleDownloadExcel}
//               >
//                 <BsFiletypeXlsx className="fs-5" /> Download Excel
//               </Button>

//               {isNewStatusPage() && selectedLeads.length > 0 && (
//                 <Button variant="danger" onClick={handleDeleteSelected}>
//                   Delete Selected ({selectedLeads.length})
//                 </Button>
//               )}

//               <button
//                 className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//                 onClick={handleToggle}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTERS */}
//               {isFilterActive && (
//                 <div className="d-flex gap-2 mb-3 flex-wrap-mobile">
//                   <input
//                     type="text"
//                     placeholder="Name"
//                     value={filters.name}
//                     onChange={(e) =>
//                       setFilters({ ...filters, name: e.target.value })
//                     }
//                   />
//                   <input
//                     type="date"
//                     value={filters.from_date}
//                     onChange={(e) =>
//                       setFilters({ ...filters, from_date: e.target.value })
//                     }
//                   />
//                   <input
//                     type="date"
//                     value={filters.to_date}
//                     onChange={(e) =>
//                       setFilters({ ...filters, to_date: e.target.value })
//                     }
//                   />
//                   <input
//                     type="text"
//                     placeholder="Mobile"
//                     value={filters.mobile}
//                     onChange={(e) =>
//                       setFilters({ ...filters, mobile: e.target.value })
//                     }
//                   />
//                   <input
//                     type="text"
//                     placeholder="Requirement"
//                     value={filters.requirement}
//                     onChange={(e) =>
//                       setFilters({ ...filters, requirement: e.target.value })
//                     }
//                   />
//                   <select
//                     value={filters.status}
//                     onChange={(e) =>
//                       setFilters({ ...filters, status: e.target.value })
//                     }
//                   >
//                     <option value="">All Status</option>
//                     <option value="Already Purchased">Already Purchased</option>
//                     <option value="Call not Pickup">Call not Pickup</option>
//                     <option value="Customer Self Call Back When He Will Come">
//                       Customer Self Call Back When He Will Come
//                     </option>
//                     <option value="In Follow Up">In Follow Up</option>
//                     <option value="Details sent visit not done">
//                       Details sent visit not done
//                     </option>
//                     <option value="In Follow Up Booking Done">
//                       In Follow Up Booking Done
//                     </option>
//                     <option value="In Follow Up Booking Done Payment Pending">
//                       In Follow Up Booking Done Payment Pending
//                     </option>
//                     <option value="In Follow Up Hot">In Follow Up Hot</option>
//                     <option value="In Follow Up Site Visit Done Booking Pending">
//                       In Follow Up Site Visit Done Booking Pending
//                     </option>
//                     <option value="Invalid Mobile Number">
//                       Invalid Mobile Number
//                     </option>
//                     <option value="Looking in Commercial Use">
//                       Looking in Commercial Use
//                     </option>
//                     <option value="Looking in Different Location">
//                       Looking in Different Location
//                     </option>
//                     <option value="Looking in Low Budget">
//                       Looking in Low Budget
//                     </option>
//                     <option value="M Profile">M Profile</option>
//                     <option value="Not Interested">Not Interested</option>
//                     <option value="Not Responding">Not Responding</option>
//                     <option value="New">New</option>
//                   </select>
//                   <Button onClick={handleSearch}>Search</Button>
//                 </div>
//               )}

//               {/* TABLE */}
//               {listLoading ? (
//                 <p>Loading leads...</p>
//               ) : leads.length === 0 ? (
//                 <p>No leads found.</p>
//               ) : (
//                 <>
//                   <Table striped bordered hover responsive>
//                     <thead>
//                       <tr>
//                         {isNewStatusPage() && (
//                           <th>
//                             Check All
//                             <Form.Check
//                               type="checkbox"
//                               checked={selectAll}
//                               onChange={handleSelectAll}
//                             />
//                           </th>
//                         )}
//                         <th>#</th>
//                         <th>Name</th>
//                         <th>Mobile</th>
//                         <th>Alt Mobile</th>
//                         <th>City</th>
//                         <th>Lead Date</th>
//                         <th>Budget</th>
//                         <th>Assign By</th>
//                         <th>Assign To</th>
//                         <th>Job Title</th>
//                         <th>PlatForm</th>
//                         <th>Requirement</th>
//                         <th>Remark</th>
//                         <th>Status</th>
//                         <th>Next Follow Up Date</th>
//                         <th>Next Follow Up Timing</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {leads.map((lead, idx) => (
//                         <tr key={lead.id || idx}>
//                           {isNewStatusPage() && (
//                             <td>
//                               <Form.Check
//                                 type="checkbox"
//                                 checked={selectedLeads.includes(lead.id)}
//                                 onChange={() => handleCheckboxChange(lead.id)}
//                               />
//                             </td>
//                           )}
//                           <td>{(page - 1) * 100 + idx + 1}</td>
//                           <td>{toSentenceCase(lead.name)}</td>
//                           <td>{lead.mobile}</td>
//                           <td>{lead.alt_mobile || "-"}</td>
//                           <td>{toSentenceCase(lead.city)}</td>
//                           <td>
//                             {(() => {
//                               if (!lead.lead_date) return "—";
//                               const date = new Date(lead.lead_date);
//                               if (isNaN(date)) return "Invalid Date";
//                               const day = String(date.getDate()).padStart(2, "0");
//                               const month = String(
//                                 date.getMonth() + 1,
//                               ).padStart(2, "0");
//                               const year = date.getFullYear();
//                               return `${day}-${month}-${year}`;
//                             })()}
//                           </td>
//                           <td>{toSentenceCase(lead.budget) || "-"}</td>
//                           <td>
//                             <div className="table-cell-remark">
//                               {lead.assign_by_subadmin_email
//                                 ? lead.assign_by_subadmin_email
//                                 : "-"}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="table-cell-remark">
//                               {lead.assign_to_subadmin_email
//                                 ? lead.assign_to_subadmin_email
//                                 : "-"}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="table-cell-remark">
//                               {toSentenceCase(lead.job_title)}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="table-cell-remark">
//                               {toSentenceCase(lead.plat_form)}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="table-cell-remark">
//                               {toSentenceCase(lead.requirement)}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="table-cell-remark">
//                               {toSentenceCase(lead.remark) || "-"}
//                             </div>
//                           </td>
//                           <td>
//                             <strong
//                               style={{
//                                 color: lead.status === "New" ? "green" : "red",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               {toSentenceCase(lead.status)}
//                             </strong>
//                           </td>
//                           <td>
//                             {(() => {
//                               if (!lead.next_follow_up_date) return "—";
//                               let dateString = lead.next_follow_up_date;
//                               if (dateString.includes("-")) {
//                                 const parts = dateString.split("-");
//                                 if (parts[0].length === 2) {
//                                   dateString = `${parts[2]}-${parts[1]}-${parts[0]}`;
//                                 }
//                               }
//                               const date = new Date(dateString);
//                               if (isNaN(date)) return "Invalid Date";
//                               const day = String(date.getDate()).padStart(2, "0");
//                               const month = String(
//                                 date.getMonth() + 1,
//                               ).padStart(2, "0");
//                               const year = date.getFullYear();
//                               const formattedDate = `${day}-${month}-${year}`;
//                               const today = new Date();
//                               let color = "black";
//                               if (
//                                 date.getFullYear() === today.getFullYear() &&
//                                 date.getMonth() === today.getMonth() &&
//                                 date.getDate() === today.getDate()
//                               ) {
//                                 color = "green";
//                               } else if (date < today) {
//                                 color = "red";
//                               }
//                               return (
//                                 <span style={{ color }}>{formattedDate}</span>
//                               );
//                             })()}
//                           </td>
//                           <td>
//                             {lead.followup_time
//                               ? (() => {
//                                   const followUpDate = new Date(
//                                     lead.next_follow_up_date,
//                                   );
//                                   const today = new Date();
//                                   today.setHours(0, 0, 0, 0);
//                                   followUpDate.setHours(0, 0, 0, 0);
//                                   let color = "black";
//                                   if (
//                                     followUpDate.getTime() === today.getTime()
//                                   ) {
//                                     color = "green";
//                                   } else if (followUpDate < today) {
//                                     color = "red";
//                                   }
//                                   const [hourStr, min] =
//                                     lead.followup_time.split(":");
//                                   let hour = parseInt(hourStr);
//                                   const ampm = hour >= 12 ? "PM" : "AM";
//                                   hour = hour % 12;
//                                   if (hour === 0) hour = 12;
//                                   const time12 = `${String(hour).padStart(2, "0")}:${min} ${ampm}`;
//                                   return (
//                                     <span style={{ color }}>{time12}</span>
//                                   );
//                                 })()
//                               : "-"}
//                           </td>
//                           <td className="d-flex gap-2">
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 id={`dropdownMenuButton-${lead.id}`}
//                                 data-bs-toggle="dropdown"
//                                 aria-expanded="false"
//                               >
//                                 <BsThreeDots size={20} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 aria-labelledby={`dropdownMenuButton-${lead.id}`}
//                               >
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm me-1"
//                                     onClick={() => handleEditLead(lead.id)}
//                                     title="Update"
//                                   >
//                                     <MdSecurityUpdateGood className="me-2" />{" "}
//                                     Update
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn edit_btn btn-sm me-1"
//                                     onClick={() =>
//                                       navigate(
//                                         `/convert-calling-lead/${lead.id}`,
//                                       )
//                                     }
//                                     title="Convert"
//                                   >
//                                     <SiConvertio className="me-2" /> Convert
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn btn-danger btn-sm"
//                                     title="Calling Remark History"
//                                     onClick={() =>
//                                       navigate(
//                                         `/calling-remark-history/${lead.id}`,
//                                       )
//                                     }
//                                   >
//                                     <MdOutlineHistoryToggleOff className="me-2" />{" "}
//                                     Calling Remark History
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>

//                   {/* Pagination */}
//                   <div className="d-flex justify-content-end">
//                     <Pagination>
//                       <Pagination.Prev
//                         onClick={() => handlePageChange(page - 1)}
//                         disabled={page === 1}
//                       />
//                       <Pagination.Item
//                         active={1 === page}
//                         onClick={() => handlePageChange(1)}
//                       >
//                         1
//                       </Pagination.Item>
//                       {page > 3 && <Pagination.Ellipsis />}
//                       {page > 2 && (
//                         <Pagination.Item
//                           onClick={() => handlePageChange(page - 1)}
//                         >
//                           {page - 1}
//                         </Pagination.Item>
//                       )}
//                       {page !== 1 && page !== totalPages && (
//                         <Pagination.Item active>{page}</Pagination.Item>
//                       )}
//                       {page < totalPages - 1 && (
//                         <Pagination.Item
//                           onClick={() => handlePageChange(page + 1)}
//                         >
//                           {page + 1}
//                         </Pagination.Item>
//                       )}
//                       {page < totalPages - 2 && <Pagination.Ellipsis />}
//                       {totalPages > 1 && (
//                         <Pagination.Item
//                           active={totalPages === page}
//                           onClick={() => handlePageChange(totalPages)}
//                         >
//                           {totalPages}
//                         </Pagination.Item>
//                       )}
//                       <Pagination.Next
//                         onClick={() => handlePageChange(page + 1)}
//                         disabled={page === totalPages}
//                       />
//                     </Pagination>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* ============ MODALS ============ */}

//       {/* CSV Upload Modal */}
//       {/* <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload Property Social Media Leads CSV</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-center">
//           <input
//             type="file"
//             accept=".csv"
//             ref={inputRef}
//             onChange={(e) => setFile(e.target.files[0])}
//             style={{ display: "none" }}
//           />
//           <Button onClick={() => inputRef.current && inputRef.current.click()}>
//             {file ? "Change CSV" : "Select CSV"}
//           </Button>
//           <p className="mt-2">{file ? file.name : "No file selected"}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <div className="d-flex justify-content-between w-100">
//             <div className="downloadtemplate">
//               <a href={callingleads} download="Lead Formate.csv">
//                 <Button variant="success">Download Excel Template</Button>
//               </a>
//             </div>
//             <div className="d-flex gap-2">
//               <Button
//                 variant="success"
//                 disabled={loading}
//                 onClick={handleUploadSubmit}
//               >
//                 {loading ? "Uploading..." : "Upload"}
//               </Button>
//               <Button variant="danger" onClick={() => setShowModal(false)}>
//                 Close
//               </Button>
//             </div>
//           </div>
//         </Modal.Footer>
//       </Modal> */}

//             {/* CSV Upload Modal */}
//       <Modal
//         show={showModal}
//         onHide={() => {
//           setShowModal(false);
//           setFile(null);
//         }}
//         centered
//         size="lg"
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//             color: "#ffffff",
//             borderTopLeftRadius: "12px",
//             borderTopRightRadius: "12px",
//             borderBottom: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title
//             style={{
//               fontSize: "18px",
//               fontWeight: "700",
//               letterSpacing: "0.3px",
//               display: "flex",
//               alignItems: "center",
//               gap: "10px",
//               color: "#ffffff",
//             }}
//           >
//             <FaFileCsv style={{ fontSize: "22px" }} />
//             Upload Social Media Leads CSV
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body
//           style={{
//             background: "#f8fafc",
//             padding: "30px 24px",
//           }}
//         >
//           {/* Info banner */}
//           <div
//             style={{
//               background: "#eff6ff",
//               border: "1.5px solid #bfdbfe",
//               borderRadius: "10px",
//               padding: "12px 16px",
//               marginBottom: "20px",
//               display: "flex",
//               alignItems: "center",
//               gap: "10px",
//             }}
//           >
//             <span style={{ fontSize: "18px" }}>ℹ️</span>
//             <span
//               style={{
//                 fontSize: "13px",
//                 color: "#1e3a5f",
//                 fontWeight: "500",
//               }}
//             >
//               Only <strong>.csv</strong> files are allowed. Please follow the
//               template format for successful import.
//             </span>
//           </div>

//           {/* File drop / select area */}
//           <div
//             onClick={() =>
//               inputRef.current && inputRef.current.click()
//             }
//             style={{
//               border: "2px dashed #93c5fd",
//               borderRadius: "14px",
//               padding: "40px 20px",
//               textAlign: "center",
//               cursor: "pointer",
//               background: file ? "#f0fdf4" : "#ffffff",
//               borderColor: file ? "#22c55e" : "#93c5fd",
//               transition: "all 0.25s ease",
//             }}
//           >
//             <input
//               type="file"
//               accept=".csv"
//               ref={inputRef}
//               onChange={(e) => setFile(e.target.files[0])}
//               style={{ display: "none" }}
//             />

//             <div
//               style={{
//                 width: "64px",
//                 height: "64px",
//                 margin: "0 auto 14px",
//                 borderRadius: "50%",
//                 background: file
//                   ? "linear-gradient(135deg, #16a34a, #22c55e)"
//                   : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "28px",
//                 boxShadow: file
//                   ? "0 8px 20px rgba(34, 197, 94, 0.3)"
//                   : "0 8px 20px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               {file ? "✓" : <FaFileCsv />}
//             </div>

//             <h5
//               style={{
//                 margin: "0 0 6px",
//                 fontSize: "15px",
//                 fontWeight: "700",
//                 color: "#1e3a5f",
//               }}
//             >
//               {file ? "File Selected" : "Click to Select CSV File"}
//             </h5>
//             <p
//               style={{
//                 margin: 0,
//                 fontSize: "13px",
//                 color: file ? "#16a34a" : "#64748b",
//                 fontWeight: "500",
//                 wordBreak: "break-all",
//               }}
//             >
//               {file ? file.name : "or drag and drop your CSV here"}
//             </p>

//             {file && (
//               <p
//                 style={{
//                   margin: "10px 0 0",
//                   fontSize: "12px",
//                   color: "#64748b",
//                 }}
//               >
//                 {(file.size / 1024).toFixed(1)} KB
//               </p>
//             )}
//           </div>

//           {/* Template download */}
//           <div
//             style={{
//               marginTop: "20px",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <a
//               href={callingleads}
//               download="Lead Formate.csv"
//               style={{ textDecoration: "none" }}
//             >
//               <button
//                 type="button"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "10px 20px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #1e5799",
//                   background: "#ffffff",
//                   color: "#1e5799",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                 }}
//               >
//                 <BsFiletypeXlsx style={{ fontSize: "16px" }} />
//                 Download CSV Template
//               </button>
//             </a>
//           </div>
//         </Modal.Body>

//         <Modal.Footer
//           style={{
//             borderTop: "1.5px dashed #e2e8f0",
//             padding: "16px 24px",
//             background: "#ffffff",
//             display: "flex",
//             justifyContent: "space-between",
//           }}
//         >
//           <Button
//             variant="outline-secondary"
//             onClick={() => {
//               setShowModal(false);
//               setFile(null);
//             }}
//             style={{
//               borderRadius: "10px",
//               fontWeight: "600",
//               padding: "9px 20px",
//             }}
//           >
//             Cancel
//           </Button>

//           <button
//             type="button"
//             onClick={handleUploadSubmit}
//             disabled={loading || !file}
//             style={{
//               padding: "11px 32px",
//               borderRadius: "10px",
//               border: "none",
//               background:
//                 loading || !file
//                   ? "#cbd5e1"
//                   : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//               color: "#ffffff",
//               fontSize: "14px",
//               fontWeight: "800",
//               letterSpacing: "0.4px",
//               cursor: loading || !file ? "not-allowed" : "pointer",
//               transition: "all 0.3s ease",
//               boxShadow:
//                 loading || !file
//                   ? "none"
//                   : "0 8px 20px rgba(30, 87, 153, 0.3)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "10px",
//               minWidth: "140px",
//             }}
//           >
//             {loading ? (
//               <>
//                 <span
//                   style={{
//                     width: "14px",
//                     height: "14px",
//                     border: "2px solid rgba(255,255,255,0.3)",
//                     borderTop: "2px solid #ffffff",
//                     borderRadius: "50%",
//                     display: "inline-block",
//                     animation: "spin 0.8s linear infinite",
//                   }}
//                 />
//                 Uploading...
//               </>
//             ) : (
//               "Upload CSV"
//             )}
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Lead Modal */}
//       <Modal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Update Calling Leads</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-2">
//               <Form.Label>Status</Form.Label>
//               <Form.Select
//                 value={editData.status || ""}
//                 onChange={(e) =>
//                   setEditData({ ...editData, status: e.target.value })
//                 }
//                 className="text-dark"
//               >
//                 <option value="">All Status</option>
//                 <option value="Already Purchased">Already Purchased</option>
//                 <option value="Call not Pickup">Call not Pickup</option>
//                 <option value="Customer Self Call Back When He Will Come">
//                   Customer Self Call Back When He Will Come
//                 </option>
//                 <option value="In Follow Up">In Follow Up</option>
//                 <option value="Details sent visit not done">
//                   Details sent visit not done
//                 </option>
//                 <option value="In Follow Up Booking Done">
//                   In Follow Up Booking Done
//                 </option>
//                 <option value="In Follow Up Booking Done Payment Pending">
//                   In Follow Up Booking Done Payment Pending
//                 </option>
//                 <option value="In Follow Up Hot">In Follow Up Hot</option>
//                 <option value="In Follow Up Site Visit Done Booking Pending">
//                   In Follow Up Site Visit Done Booking Pending
//                 </option>
//                 <option value="Invalid Mobile Number">Invalid Mobile Number</option>
//                 <option value="Looking in Commercial Use">
//                   Looking in Commercial Use
//                 </option>
//                 <option value="Looking in Different Location">
//                   Looking in Different Location
//                 </option>
//                 <option value="Looking in Low Budget">Looking in Low Budget</option>
//                 <option value="M Profile">M Profile</option>
//                 <option value="Not Interested">Not Interested</option>
//                 <option value="Not Responding">Not Responding</option>
//                 <option value="New">New</option>
//               </Form.Select>
//             </Form.Group>

//             <Form.Group className="mb-2">
//               <Form.Label>Remark</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={editData.remark}
//                 onChange={(e) =>
//                   setEditData({ ...editData, remark: e.target.value })
//                 }
//               />
//             </Form.Group>

//             <Form.Group className="mb-2">
//               <Form.Label>Next Follow Up Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={editData.next_follow_up_date}
//                 onChange={(e) =>
//                   setEditData({
//                     ...editData,
//                     next_follow_up_date: e.target.value,
//                   })
//                 }
//               />
//             </Form.Group>

//             <Form.Group className="mb-2">
//               <Form.Label>Next Follow Up Time</Form.Label>
//               <div className="d-flex">
//                 <Form.Control
//                   type="time"
//                   value={editData.followup_time || ""}
//                   onChange={(e) =>
//                     setEditData({
//                       ...editData,
//                       followup_time: e.target.value || null,
//                     })
//                   }
//                   placeholder="NA"
//                 />
//                 <button
//                   type="button"
//                   className="btn btn-outline-secondary ms-2"
//                   onClick={() =>
//                     setEditData({ ...editData, followup_time: null })
//                   }
//                 >
//                   NA
//                 </button>
//               </div>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleUpdateLead}>
//             Update
//           </Button>
//           <Button variant="danger" onClick={() => setShowEditModal(false)}>
//             Cancel
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );


// }

// export default UploadPropertyLeadCSV;
import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import callingleads from "../../assets/images/Lead Formate.csv";
import { useNavigate, useLocation, Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { BsThreeDots, BsFiletypeXlsx } from "react-icons/bs";
import { MdSecurityUpdateGood } from "react-icons/md";
import { SiConvertio } from "react-icons/si";
import { MdOutlineHistoryToggleOff } from "react-icons/md";
import { FaFileCsv } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 100;

function UploadPropertyLeadCSV() {
  const location = useLocation();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const inputRef = useRef(null);
  const token = localStorage.getItem("token");

  const [filters, setFilters] = useState({
    name: "",
    mobile: "",
    requirement: "",
    status: "",
    from_date: "",
    to_date: "",
  });

  const [editData, setEditData] = useState({
    id: "",
    status: "",
    remark: "",
    next_follow_up_date: "",
    followup_time: "",
  });

  const isNewStatusPage = () => {
    const params = new URLSearchParams(location.search);
    return params.get("status") === "New";
  };

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const toSentenceCase = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH LEADS
  // ═══════════════════════════════════════════
  const fetchLeads = async (searchParams = {}, currentPage = 1) => {
    setListLoading(true);
    try {
      const params = new URLSearchParams({
        ...searchParams,
        page: currentPage,
        limit: LIMIT,
      }).toString();

      const res = await fetch(`${API_URL}/lead-csv-list?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      if (res.ok && data?.status === "1") {
        setLeads(data.data || []);
        setPage(currentPage);
        const pages = Number(data.totalPages) || 1;
        const total = Number(data.total) || (data.data?.length || 0);
        setTotalPages(pages);
        setTotalItems(total);
        setSelectedLeads([]);
        setSelectAll(false);
      } else {
        Swal.fire("Error", data?.message || "Failed to fetch leads", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Network error while fetching leads", "error");
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    if (statusParam) {
      setIsFilterActive(true);
      const newFilters = { ...filters, status: statusParam };
      setFilters(newFilters);
      fetchLeads(newFilters, 1);
    } else {
      fetchLeads(filters, 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleSearch = () => {
    setPage(1);
    fetchLeads(filters, 1);
  };

  const handleClearSearch = () => {
    const cleared = {
      name: "",
      mobile: "",
      requirement: "",
      status: "",
      from_date: "",
      to_date: "",
    };
    setFilters(cleared);
    setPage(1);
    fetchLeads(cleared, 1);
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    fetchLeads(filters, newPage);
  };

  // ═══════════════════════════════════════════
  // 🔹 SELECT / DELETE
  // ═══════════════════════════════════════════
  const handleCheckboxChange = (leadId) => {
    setSelectedLeads((prev) =>
      prev.includes(leadId)
        ? prev.filter((id) => id !== leadId)
        : [...prev, leadId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedLeads([]);
    } else {
      setSelectedLeads(leads.map((lead) => lead.id));
    }
    setSelectAll(!selectAll);
  };

  const handleDeleteSelected = async () => {
    if (selectedLeads.length === 0) {
      Swal.fire("Warning", "Please select at least one lead to delete", "warning");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete ${selectedLeads.length} lead(s). This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Delete",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await fetch(`${API_URL}/lead-delete-list-only-new`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ids: selectedLeads }),
        });

        const data = await res.json();

        if (res.ok && data?.status == "1") {
          Swal.fire(
            "Success",
            data?.message || "Leads deleted successfully!",
            "success"
          );
          setSelectedLeads([]);
          setSelectAll(false);
          fetchLeads(filters, page);
        } else {
          Swal.fire("Error", data?.message || "Failed to delete leads", "error");
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Network error while deleting leads", "error");
      }
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 CSV UPLOAD
  // ═══════════════════════════════════════════
  const handleUploadSubmit = async () => {
    if (!file) {
      Swal.fire("Warning", "Please select a CSV file!", "warning");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("leadCsv", file);

      const res = await fetch(`${API_URL}/lead-create-csv`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();

      if (res.ok && data?.success === "1") {
        Swal.fire(
          "Success",
          data?.message || "CSV uploaded successfully!",
          "success"
        );
        setShowModal(false);
        setFile(null);
        fetchLeads(filters, page);
      } else {
        Swal.fire("Error", data?.message || "Failed to upload CSV", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.message || "Network error while uploading CSV",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT LEAD
  // ═══════════════════════════════════════════
  const handleEditLead = async (leadId) => {
    try {
      const res = await fetch(`${API_URL}/lead-csv-edit`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: leadId }),
      });

      const data = await res.json();

      if (res.ok && data?.status === "1" && data?.data?.length > 0) {
        const lead = data.data[0];
        setEditData({
          id: lead.id,
          name: lead.name || "",
          mobile: lead.mobile || "",
          alt_mobile: lead.alt_mobile || "",
          city: lead.city || "",
          job_title: lead.job_title || "",
          budget: lead.budget || "",
          requirement: lead.requirement || "",
          status: lead.status || "",
          remark: lead.remark || "",
          followup_time: lead.followup_time || "",
          next_follow_up_date: lead.next_follow_up_date || "",
          assign_by_subadmin: lead.assign_by_subadmin || "",
          assign_by_subadmin_email: lead.assign_by_subadmin_email || "",
        });
        setShowEditModal(true);
      } else {
        Swal.fire(
          "Error",
          data?.message || "Failed to fetch lead details",
          "error"
        );
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Network error while fetching lead details", "error");
    }
  };

  const handleUpdateLead = async () => {
    try {
      const res = await fetch(`${API_URL}/lead-csv-update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editData),
      });

      const data = await res.json();

      if (res.ok && data?.success === "1") {
        Swal.fire(
          "Success",
          data?.message || "Lead updated successfully!",
          "success"
        );
        setShowEditModal(false);
        fetchLeads(filters, page);
      } else {
        Swal.fire("Error", data?.message || "Failed to update lead", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Network error while updating lead", "error");
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 DOWNLOAD EXCEL
  // ═══════════════════════════════════════════
  const handleDownloadExcel = async () => {
    try {
      const res = await fetch(`${API_URL}/lead-csv-list-export`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch data");
      const json = await res.json();
      const ws = XLSX.utils.json_to_sheet(json.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Leads");
      XLSX.writeFile(wb, "leads.xlsx");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Excel download failed", "error");
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && page > 4) pages.push("left-ellipsis");

    const start = Math.max(2, page - 2);
    const end = Math.min(totalPages - 1, page + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && page < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                📞
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Social Media Leads
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage, upload and convert your leads ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <Link
                to="/calling-create-lead"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Add Lead
              </Link>

              <button
                onClick={() => setShowModal(true)}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #7c3aed, #6d28d9)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(124, 58, 237, 0.3)",
                }}
              >
                <FaFileCsv /> Upload CSV
              </button>

              <button
                onClick={handleDownloadExcel}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                }}
              >
                <BsFiletypeXlsx /> Download
              </button>

              {isNewStatusPage() && selectedLeads.length > 0 && (
                <button
                  onClick={handleDeleteSelected}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "10px",
                    border: "none",
                    background: "linear-gradient(135deg, #dc2626, #b91c1c)",
                    color: "#ffffff",
                    fontSize: "13px",
                    fontWeight: "700",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 6px 18px rgba(220, 38, 38, 0.3)",
                  }}
                >
                  🗑 Delete ({selectedLeads.length})
                </button>
              )}

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: 1, minWidth: "140px" }}>
                  <label style={labelStyle}>Name</label>
                  <input
                    type="text"
                    placeholder="Name"
                    value={filters.name}
                    onChange={(e) =>
                      setFilters({ ...filters, name: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "140px" }}>
                  <label style={labelStyle}>Mobile</label>
                  <input
                    type="text"
                    placeholder="Mobile"
                    value={filters.mobile}
                    onChange={(e) =>
                      setFilters({ ...filters, mobile: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>Requirement</label>
                  <input
                    type="text"
                    placeholder="Requirement"
                    value={filters.requirement}
                    onChange={(e) =>
                      setFilters({ ...filters, requirement: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "160px" }}>
                  <label style={labelStyle}>Status</label>
                  <select
                    value={filters.status}
                    onChange={(e) =>
                      setFilters({ ...filters, status: e.target.value })
                    }
                    style={inputStyle}
                  >
                    <option value="">All Status</option>
                    <option value="Already Purchased">Already Purchased</option>
                    <option value="Call not Pickup">Call not Pickup</option>
                    <option value="Customer Self Call Back When He Will Come">
                      Customer Self Call Back
                    </option>
                    <option value="In Follow Up">In Follow Up</option>
                    <option value="Details sent visit not done">
                      Details sent visit not done
                    </option>
                    <option value="In Follow Up Booking Done">
                      In Follow Up Booking Done
                    </option>
                    <option value="In Follow Up Booking Done Payment Pending">
                      Booking Done Payment Pending
                    </option>
                    <option value="In Follow Up Hot">In Follow Up Hot</option>
                    <option value="In Follow Up Site Visit Done Booking Pending">
                      Site Visit Done Booking Pending
                    </option>
                    <option value="Invalid Mobile Number">
                      Invalid Mobile Number
                    </option>
                    <option value="Looking in Commercial Use">
                      Commercial Use
                    </option>
                    <option value="Looking in Different Location">
                      Different Location
                    </option>
                    <option value="Looking in Low Budget">Low Budget</option>
                    <option value="M Profile">M Profile</option>
                    <option value="Not Interested">Not Interested</option>
                    <option value="Not Responding">Not Responding</option>
                    <option value="New">New</option>
                  </select>
                </div>

                <div style={{ flex: 1, minWidth: "140px" }}>
                  <label style={labelStyle}>From Date</label>
                  <input
                    type="date"
                    value={filters.from_date}
                    onChange={(e) =>
                      setFilters({ ...filters, from_date: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "140px" }}>
                  <label style={labelStyle}>To Date</label>
                  <input
                    type="date"
                    value={filters.to_date}
                    onChange={(e) =>
                      setFilters({ ...filters, to_date: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={handleSearch}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    onClick={handleClearSearch}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      color: "#64748b",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}

            {/* Table */}
            {listLoading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  color: "#64748b",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    border: "3px solid #cbd5e1",
                    borderTop: "3px solid #2b6cb0",
                    borderRadius: "50%",
                    display: "inline-block",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                <p
                  style={{
                    marginTop: "16px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Loading leads...
                </p>
              </div>
            ) : leads.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "50px",
                  color: "#94a3b8",
                  fontWeight: "600",
                }}
              >
                📭 No leads found.
              </div>
            ) : (
              <>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "visible",
                    borderRadius: "14px",
                    border: "1.5px solid #e2e8f0",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      minWidth: "1600px",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        }}
                      >
                        {isNewStatusPage() && (
                          <th
                            style={{
                              padding: "14px 12px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11.5px",
                              textAlign: "left",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  cursor: "pointer",
                                }}
                              />
                              All
                            </div>
                          </th>
                        )}
                        {[
                          "S.N",
                          "Name",
                          "Mobile",
                          "Alt Mobile",
                          "City",
                          "Lead Date",
                          "Budget",
                          "Assign By",
                          "Assign To",
                          "Job Title",
                          "Platform",
                          "Requirement",
                          "Remark",
                          "Status",
                          "Next Follow Up",
                          "Follow Up Time",
                          "Actions",
                        ].map((th, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "14px 12px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11.5px",
                              textAlign: "left",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {leads.map((lead, idx) => (
                        <tr
                          key={lead.id || idx}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          {isNewStatusPage() && (
                            <td style={{ padding: "12px" }}>
                              <input
                                type="checkbox"
                                checked={selectedLeads.includes(lead.id)}
                                onChange={() => handleCheckboxChange(lead.id)}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  cursor: "pointer",
                                }}
                              />
                            </td>
                          )}
                          <td style={cellBlue}>
                            {(page - 1) * LIMIT + idx + 1}
                          </td>
                          <td style={cellDark}>{toSentenceCase(lead.name)}</td>
                          <td style={cellGray}>{lead.mobile || "-"}</td>
                          <td style={cellGray}>{lead.alt_mobile || "-"}</td>
                          <td style={cellGray}>
                            {toSentenceCase(lead.city) || "-"}
                          </td>
                          <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                            {lead.lead_date
                              ? (() => {
                                  const date = new Date(lead.lead_date);
                                  if (isNaN(date)) return "Invalid Date";
                                  const day = String(date.getDate()).padStart(
                                    2,
                                    "0"
                                  );
                                  const month = String(
                                    date.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = date.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()
                              : "-"}
                          </td>
                          <td style={cellGray}>
                            {toSentenceCase(lead.budget) || "-"}
                          </td>
                          <td style={cellGray}>
                            {lead.assign_by_subadmin_email || "-"}
                          </td>
                          <td style={cellGray}>
                            {lead.assign_to_subadmin_email || "-"}
                          </td>
                          <td style={cellGray}>
                            {toSentenceCase(lead.job_title) || "-"}
                          </td>
                          <td style={cellGray}>
                            {toSentenceCase(lead.plat_form) || "-"}
                          </td>
                          <td style={cellGray}>
                            {toSentenceCase(lead.requirement) || "-"}
                          </td>
                          <td style={cellGray}>
                            {toSentenceCase(lead.remark) || "-"}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 12px",
                                borderRadius: "20px",
                                fontSize: "11.5px",
                                fontWeight: "700",
                                background:
                                  lead.status === "New"
                                    ? "#e7f9eb"
                                    : "#feeaeb",
                                color:
                                  lead.status === "New"
                                    ? "#059669"
                                    : "#dc2626",
                                textTransform: "capitalize",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {toSentenceCase(lead.status) || "-"}
                            </span>
                          </td>
                          <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                            {lead.next_follow_up_date
                              ? (() => {
                                  let dateString = lead.next_follow_up_date;
                                  if (dateString.includes("-")) {
                                    const parts = dateString.split("-");
                                    if (parts[0].length === 2) {
                                      dateString = `${parts[2]}-${parts[1]}-${parts[0]}`;
                                    }
                                  }
                                  const date = new Date(dateString);
                                  if (isNaN(date)) return "Invalid Date";
                                  const day = String(date.getDate()).padStart(
                                    2,
                                    "0"
                                  );
                                  const month = String(
                                    date.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = date.getFullYear();
                                  const formattedDate = `${day}-${month}-${year}`;
                                  const today = new Date();
                                  let color = "#334155";
                                  if (
                                    date.getFullYear() === today.getFullYear() &&
                                    date.getMonth() === today.getMonth() &&
                                    date.getDate() === today.getDate()
                                  ) {
                                    color = "#059669";
                                  } else if (date < today) {
                                    color = "#dc2626";
                                  }
                                  return (
                                    <span style={{ color, fontWeight: "600" }}>
                                      {formattedDate}
                                    </span>
                                  );
                                })()
                              : "-"}
                          </td>
                          <td style={cellGray}>
                            {lead.followup_time
                              ? (() => {
                                  const [hourStr, min] =
                                    lead.followup_time.split(":");
                                  let hour = parseInt(hourStr);
                                  const ampm = hour >= 12 ? "PM" : "AM";
                                  hour = hour % 12;
                                  if (hour === 0) hour = 12;
                                  return `${String(hour).padStart(
                                    2,
                                    "0"
                                  )}:${min} ${ampm}`;
                                })()
                              : "-"}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <div className="dropdown">
                              <button
                                className="btn dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                data-bs-boundary="viewport"
                                data-bs-popper-config='{"strategy":"fixed"}'
                                aria-expanded="false"
                                style={{
                                  background: "#f8fafc",
                                  border: "1.5px solid #e2e8f0",
                                  borderRadius: "8px",
                                  width: "36px",
                                  height: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#1e5799",
                                  padding: 0,
                                }}
                              >
                                <BsThreeDots size={18} />
                              </button>
                              <ul
                                className="dropdown-menu"
                                style={{
                                  zIndex: 9999,
                                  borderRadius: "14px",
                                  border: "none",
                                  padding: "8px",
                                  boxShadow:
                                    "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                  minWidth: "230px",
                                  marginTop: "8px",
                                  background: "#ffffff",
                                }}
                              >
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleEditLead(lead.id)}
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#e8f1fb";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#e8f1fb", "#1e5799")}
                                    >
                                      <MdSecurityUpdateGood size={13} />
                                    </span>
                                    Update
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() =>
                                      navigate(
                                        `/convert-calling-lead/${lead.id}`
                                      )
                                    }
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#e7f9eb";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#e7f9eb", "#059669")}
                                    >
                                      <SiConvertio size={13} />
                                    </span>
                                    Convert
                                  </button>
                                </li>

                                <li>
                                  <hr
                                    style={{
                                      margin: "6px 8px",
                                      border: "none",
                                      borderTop: "1.5px dashed #e2e8f0",
                                    }}
                                  />
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() =>
                                      navigate(
                                        `/calling-remark-history/${lead.id}`
                                      )
                                    }
                                    style={{
                                      ...dropdownItem,
                                      color: "#7c3aed",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#f3e8ff";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#f3e8ff", "#7c3aed")}
                                    >
                                      <MdOutlineHistoryToggleOff size={13} />
                                    </span>
                                    Remark History
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "24px",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: page === 1 ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: page === 1 ? "not-allowed" : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      ‹ Prev
                    </button>

                    {getPageNumbers().map((p, i) => {
                      if (p === "left-ellipsis" || p === "right-ellipsis") {
                        return (
                          <span
                            key={`ellipsis-${i}`}
                            style={{
                              padding: "0 6px",
                              color: "#94a3b8",
                              fontWeight: "700",
                            }}
                          >
                            ...
                          </span>
                        );
                      }
                      const isActive = p === page;
                      return (
                        <button
                          key={p}
                          onClick={() => handlePageChange(p)}
                          style={{
                            minWidth: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            border: isActive
                              ? "none"
                              : "1.5px solid #e2e8f0",
                            background: isActive
                              ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                              : "#ffffff",
                            color: isActive ? "#ffffff" : "#334155",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            boxShadow: isActive
                              ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                              : "none",
                            transition: "all 0.18s ease",
                          }}
                        >
                          {p}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === totalPages}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          page === totalPages ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor:
                          page === totalPages ? "not-allowed" : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                )}

                {totalItems > 0 && (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#94a3b8",
                      marginTop: "12px",
                      marginBottom: 0,
                      fontWeight: "500",
                    }}
                  >
                    Page {page} of {totalPages} • {totalItems} total records
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 CSV UPLOAD MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setFile(null);
        }}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            📄 Upload Social Media Leads CSV
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "24px", background: "#f8fafc" }}>
          <div
            style={{
              background: "#e8f1fb",
              border: "1.5px solid #bfdbfe",
              borderRadius: "10px",
              padding: "12px 16px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ fontSize: "18px" }}>ℹ️</span>
            <span
              style={{
                fontSize: "13px",
                color: "#1e3a5f",
                fontWeight: "500",
              }}
            >
              Only <strong>.csv</strong> files are allowed. Please follow the
              template format.
            </span>
          </div>

          <div
            onClick={() => inputRef.current && inputRef.current.click()}
            style={{
              border: file ? "2px dashed #22c55e" : "2px dashed #93c5fd",
              borderRadius: "14px",
              padding: "40px 20px",
              textAlign: "center",
              cursor: "pointer",
              background: file ? "#f0fdf4" : "#ffffff",
              transition: "all 0.25s ease",
            }}
          >
            <input
              type="file"
              accept=".csv"
              ref={inputRef}
              onChange={(e) => setFile(e.target.files[0])}
              style={{ display: "none" }}
            />

            <div
              style={{
                width: "64px",
                height: "64px",
                margin: "0 auto 14px",
                borderRadius: "50%",
                background: file
                  ? "linear-gradient(135deg, #16a34a, #22c55e)"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "28px",
                boxShadow: file
                  ? "0 8px 20px rgba(34, 197, 94, 0.3)"
                  : "0 8px 20px rgba(30, 87, 153, 0.3)",
              }}
            >
              {file ? "✓" : <FaFileCsv />}
            </div>

            <h5
              style={{
                margin: "0 0 6px",
                fontSize: "15px",
                fontWeight: "700",
                color: "#1e3a5f",
              }}
            >
              {file ? "File Selected" : "Click to Select CSV File"}
            </h5>
            <p
              style={{
                margin: 0,
                fontSize: "13px",
                color: file ? "#16a34a" : "#64748b",
                fontWeight: "500",
                wordBreak: "break-all",
              }}
            >
              {file ? file.name : "or drag and drop your CSV here"}
            </p>

            {file && (
              <p
                style={{
                  margin: "10px 0 0",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                {(file.size / 1024).toFixed(1)} KB
              </p>
            )}
          </div>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <a
              href={callingleads}
              download="Lead Formate.csv"
              style={{ textDecoration: "none" }}
            >
              <button
                type="button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1.5px solid #1e5799",
                  background: "#ffffff",
                  color: "#1e5799",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                <BsFiletypeXlsx /> Download CSV Template
              </button>
            </a>
          </div>
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1.5px dashed #e2e8f0",
            padding: "16px 24px",
            background: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <button
            type="button"
            onClick={() => {
              setShowModal(false);
              setFile(null);
            }}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleUploadSubmit}
            disabled={loading || !file}
            style={{
              padding: "11px 32px",
              borderRadius: "10px",
              border: "none",
              background:
                loading || !file
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: "800",
              cursor: loading || !file ? "not-allowed" : "pointer",
              boxShadow:
                loading || !file
                  ? "none"
                  : "0 8px 20px rgba(30, 87, 153, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              minWidth: "140px",
            }}
          >
            {loading ? "Uploading..." : "Upload CSV"}
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Update Calling Lead
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Status</Form.Label>
              <Form.Select
                value={editData.status || ""}
                onChange={(e) =>
                  setEditData({ ...editData, status: e.target.value })
                }
                style={inputStyle}
              >
                <option value="">All Status</option>
                <option value="Already Purchased">Already Purchased</option>
                <option value="Call not Pickup">Call not Pickup</option>
                <option value="Customer Self Call Back When He Will Come">
                  Customer Self Call Back
                </option>
                <option value="In Follow Up">In Follow Up</option>
                <option value="Details sent visit not done">
                  Details sent visit not done
                </option>
                <option value="In Follow Up Booking Done">
                  In Follow Up Booking Done
                </option>
                <option value="In Follow Up Booking Done Payment Pending">
                  Booking Done Payment Pending
                </option>
                <option value="In Follow Up Hot">In Follow Up Hot</option>
                <option value="In Follow Up Site Visit Done Booking Pending">
                  Site Visit Done Booking Pending
                </option>
                <option value="Invalid Mobile Number">
                  Invalid Mobile Number
                </option>
                <option value="Looking in Commercial Use">Commercial Use</option>
                <option value="Looking in Different Location">
                  Different Location
                </option>
                <option value="Looking in Low Budget">Low Budget</option>
                <option value="M Profile">M Profile</option>
                <option value="Not Interested">Not Interested</option>
                <option value="Not Responding">Not Responding</option>
                <option value="New">New</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Remark</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editData.remark}
                onChange={(e) =>
                  setEditData({ ...editData, remark: e.target.value })
                }
                style={{ ...inputStyle, resize: "vertical" }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Next Follow Up Date</Form.Label>
              <Form.Control
                type="date"
                value={editData.next_follow_up_date}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    next_follow_up_date: e.target.value,
                  })
                }
                style={inputStyle}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Next Follow Up Time</Form.Label>
              <div style={{ display: "flex", gap: "8px" }}>
                <Form.Control
                  type="time"
                  value={editData.followup_time || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      followup_time: e.target.value || null,
                    })
                  }
                  style={inputStyle}
                />
                <button
                  type="button"
                  onClick={() =>
                    setEditData({ ...editData, followup_time: null })
                  }
                  style={{
                    padding: "10px 18px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: "#64748b",
                    fontSize: "13px",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                >
                  NA
                </button>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={() => setShowEditModal(false)}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleUpdateLead}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
            }}
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default UploadPropertyLeadCSV;